import request from '@/network/http'

export function getRegionTreeList() {
    return request({
        url: 'Base/Base/getRegionTreeList',
        method: 'post'
    })
}

export function getCheckupProjectList(data) {
    return request({
        url: 'Checkup/CheckupProject/getCheckupProjectList',
        method: 'post',
        data
    })
}
//机构人员
export function saveCheckupSubjectItemEvaluationInfo(data) {
    return request({
        url: 'Checkup/CheckupSubject/saveCheckupSubjectItemEvaluationInfo',
        method: 'post',
        data
    })
}



// WEBPACK FOOTER //
// ./src/apis/projectManage.js